// Module
var code = "<div id=\"V-4D683F25-E12C-499D-BFC1-C64509D7BE60\"> <div data-b-component=\"loading\" data-b-comp-isloading=\"{Binding IsLoading}\" data-b-attr-class=\"{Binding Class}\" data-b-attr-style=\"{Binding Style}\"> <div data-b-component=\"content\" data-b-comp-content=\"{Binding Content}\" class=\"stretch-content\"> </div> </div> </div> ";
// Exports
export default code;